import { render, staticRenderFns } from "./formTrailer.vue?vue&type=template&id=4e52aa64&scoped=true"
import script from "./formTrailer.vue?vue&type=script&lang=js"
export * from "./formTrailer.vue?vue&type=script&lang=js"
import style0 from "./formTrailer.vue?vue&type=style&index=0&id=4e52aa64&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e52aa64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e52aa64')) {
      api.createRecord('4e52aa64', component.options)
    } else {
      api.reload('4e52aa64', component.options)
    }
    module.hot.accept("./formTrailer.vue?vue&type=template&id=4e52aa64&scoped=true", function () {
      api.rerender('4e52aa64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/order/components/form/steps/formTrailer.vue"
export default component.exports